// src/components/Contact.jsx
import React from 'react';
import ContactHeader from './ContactHeader';
import ContactSection from './ContactSection';
import GrievanceRedressal from './GrievanceRedressal'


function Contact() {
  return (
    <div>
      <ContactHeader />
      <ContactSection />
      {/* <GrievanceRedressal /> */}
    </div>
  );
}

export default Contact;